module.exports = __webpack_public_path__ + "img/felicidade.341c2577.svg";